import { useEffect } from 'react'
import Router from 'next/router'
import { DEBUG_MODE } from '../../utilities/config'

function saveScrollPos(url: any) {
  try {
    const scrollPos: any = {
      x: document?.body?.scrollLeft,
      y: document?.body?.scrollTop,
    }
    sessionStorage.setItem(url, JSON.stringify(scrollPos))
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
}

function restoreScrollPos(url: any) {
  try {
    let st: any = sessionStorage.getItem(url)
    const scrollPos = JSON.parse(st)
    if (scrollPos) {
      document?.body?.scrollTo(scrollPos.x, scrollPos.y)
    }
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
}

export default function useScrollRestoration(router: any) {
  useEffect(() => {
    try {
      if ('scrollRestoration' in window.history) {
        let shouldScrollRestore: any = false
        window.history.scrollRestoration = 'manual'
        restoreScrollPos(router.asPath)
        const onBeforeUnload: any = (event: any) => {
          saveScrollPos(router.asPath)
          delete event['returnValue']
        }
        const onRouteChangeStart = () => {
          saveScrollPos(router.asPath)
        }
        const onRouteChangeComplete: any = (url: any) => {
          if (shouldScrollRestore) {
            shouldScrollRestore = false
            restoreScrollPos(url)
          }
        }
        window.addEventListener('beforeunload', onBeforeUnload)
        Router.events.on('routeChangeStart', onRouteChangeStart)
        Router.events.on('routeChangeComplete', onRouteChangeComplete)
        Router.beforePopState(() => {
          shouldScrollRestore = true
          return true
        })
        return () => {
          window.removeEventListener('beforeunload', onBeforeUnload)
          Router.events.off('routeChangeStart', onRouteChangeStart)
          Router.events.off('routeChangeComplete', onRouteChangeComplete)
          Router.beforePopState(() => true)
        }
      }
    } catch (e) {
      if (DEBUG_MODE) console.log(e)
    }
  }, [router])
}
